import React, { FunctionComponent, useState } from 'react'
import { CronofyCallbackNotificationSlot } from 'cronofy-elements'
import { Button, Select, Typography } from 'antd'

import LoginForm from '../../../public/login/LoginForm/LoginForm'
import SchedulerAvailabilityViewer from '../../SchedulerAvailabilityViewer/SchedulerAvailabilityViewer'

import { useAuthContext } from '../../../../context/auth'
import { TExpert } from '../../../../context/types'
import RegisterForm from '../../../public/register/RegisterForm/RegisterForm'

const { Option } = Select
const { Title } = Typography

interface StepProps {
	expert: TExpert
	duration: number
	callLengthList: number[]
	onAction?: (scheduledOn: string) => void
	onChangeDuration?: (value: number) => void
}

const Step1: FunctionComponent<StepProps> = (props) => {
	const { expert, duration, callLengthList, onAction, onChangeDuration } = props
	const { auth } = useAuthContext()
	const [slot, setSlot] = useState<CronofyCallbackNotificationSlot>()
	const [registerForm, setRegisterForm] = useState<boolean>(false)

	const handleAction = () => {
		if (!slot || !slot.start) return
		onAction(slot.start)
	}

	if (!auth.token)
		return (
			<section className="RequestCallModalStep1">
				<h3 style={{ marginBottom: 25 }}>Please Login or Register</h3>
				<div style={{ maxWidth: 480, margin: 'auto', width: '100%' }}>
					{!registerForm ? (
						<LoginForm
							onGoToRegister={() => setRegisterForm(true)}
							skipRedirect={true}
							redirectOnLogin={`/expert/${expert.slug}?showBookingModal=true`}
						/>
					) : (
						<RegisterForm
							onGoToLogin={() => setRegisterForm(false)}
							skipRedirect={true}
							redirectOnRegister={`/expert/${expert.slug}?showBookingModal=true`}
						/>
					)}
				</div>
			</section>
		)

	return (
		<section className="RequestCallModalStep1">
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<h3 style={{ marginBottom: 25 }}>Pick a time slot</h3>
				{callLengthList.length > 1 && (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Title style={{ marginBottom: 0 }} level={5}>
							Duration:
						</Title>
						<Select
							style={{ minWidth: 200, marginLeft: 20 }}
							disabled={callLengthList.length === 1}
							value={duration}
							onChange={onChangeDuration}
						>
							{callLengthList.map((item) => (
								<Option key={item} value={item}>
									{item} minutes
								</Option>
							))}
						</Select>
					</div>
				)}
			</div>
			<SchedulerAvailabilityViewer
				cronofy_account_id={expert?.profile?.user?.expertInfo?.cronofy_account_id}
				onAction={setSlot}
				duration={duration}
			/>
			<footer style={{ marginTop: 25 }}>
				<Button type="primary" shape="round" size="large" onClick={handleAction} disabled={!slot}>
					Next
				</Button>
			</footer>
		</section>
	)
}

export default Step1
